// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.version-restore-confirm {
  padding: 20px 24px 16px;
  max-width: 440px;
}
.version-restore-confirm h2 {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 600;
}
.version-restore-confirm .dialog-copy {
  margin: 0;
  padding: 0 0 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}
.version-restore-confirm .dialog-copy p {
  margin: 0 0 12px;
}
.version-restore-confirm .dialog-copy .intro {
  margin-bottom: 10px;
}
.version-restore-confirm .dialog-copy .warning-box {
  margin: 0 0 12px;
  padding: 10px 12px;
  border: 1px solid #f3c8cb;
  border-radius: 8px;
  background: #fff5f5;
  color: #7b1d1d;
  font-size: 13px;
  line-height: 1.45;
}
.version-restore-confirm .dialog-copy .result-list {
  margin: 0;
  padding-left: 18px;
}
.version-restore-confirm .dialog-copy .result-list li {
  margin: 0 0 8px;
}
.version-restore-confirm .dialog-copy .result-list li:last-child {
  margin-bottom: 0;
}
.version-restore-confirm [mat-dialog-actions] {
  padding: 8px 0 0;
  margin: 0;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/version-history-panel/version-restore-confirm-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAGI;EACE,mBAAA;AADN;AAII;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAFN;AAKI;EACE,SAAA;EACA,kBAAA;AAHN;AAKM;EACE,eAAA;AAHR;AAMM;EACE,gBAAA;AAJR;AASE;EACE,gBAAA;EACA,SAAA;EACA,QAAA;AAPJ","sourcesContent":[".version-restore-confirm {\n  padding: 20px 24px 16px;\n  max-width: 440px;\n\n  h2 {\n    margin: 0 0 12px;\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  .dialog-copy {\n    margin: 0;\n    padding: 0 0 8px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #333;\n\n    p {\n      margin: 0 0 12px;\n    }\n\n    .intro {\n      margin-bottom: 10px;\n    }\n\n    .warning-box {\n      margin: 0 0 12px;\n      padding: 10px 12px;\n      border: 1px solid #f3c8cb;\n      border-radius: 8px;\n      background: #fff5f5;\n      color: #7b1d1d;\n      font-size: 13px;\n      line-height: 1.45;\n    }\n\n    .result-list {\n      margin: 0;\n      padding-left: 18px;\n\n      li {\n        margin: 0 0 8px;\n      }\n\n      li:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  [mat-dialog-actions] {\n    padding: 8px 0 0;\n    margin: 0;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
